import React, { useEffect, useContext, useMemo } from "react";
import "./BrandsFeaturesCarousel.css";

import useEmblaCarousel from "embla-carousel-react";
import BrandFeaturesTable from "./BrandFeaturesTable";
import { MilestoneBenefitsContext } from "../../context/MilestoneBenefitsContext";
import { MilestonesContext } from "../../context/MilestonesContext";

export default function BrandsFeaturesCarousel({
  selectedBrand,
  showCarousel,
  setShowCarousel,
  brands,
}) {
  const { milestone_benefits } = useContext(MilestoneBenefitsContext);
  const { milestones } = useContext(MilestonesContext);
  
  const options = {
    align: "start",
    loop: true,
    startIndex: selectedBrand?.order ? selectedBrand.order - 1 : 0,
  };
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  // Calculate max height based on the brand with the most levels
  const maxHeight = useMemo(() => {
    if (!milestone_benefits || !milestones || !brands) {
      return { slideHeight: 725, carouselHeight: 750 }; // Default height for 6 levels
    }
    
    const rowHeight = 56;
    const baseHeight = 389; // Base height without level rows (725 - 6*56)
    
    let maxLevels = 0;
    brands.forEach((brand) => {
      const brandId = brand.brand_id;
      const brandLevels = milestones.filter((milestone) => {
        return milestone_benefits.some(
          (mb) => mb.brand_id === brandId && mb.milestone_id === milestone.milestone_id
        );
      });
      maxLevels = Math.max(maxLevels, brandLevels.length);
    });
    
    const slideHeight = baseHeight + (maxLevels * rowHeight);
    const carouselHeight = slideHeight + 25; // Carousel container is 25px taller than slide
    return { slideHeight, carouselHeight };
  }, [milestone_benefits, milestones, brands]);

  useEffect(() => {
    if (showCarousel) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [showCarousel]);

  if (showCarousel) {
    return (
      <>
        <div
          className="rewards-brands__features"
          style={{
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            borderRadius: "8px",
            zIndex: 1000,
          }}
        >
          <section 
            className="carousel__brands-features"
            style={{
              height: `${maxHeight.carouselHeight}px`,
              top: `calc((100vh - ${maxHeight.slideHeight}px) / 2)`,
            }}
          >
            <div className="brands-features__viewport" ref={emblaRef}>
              <div id="rewardsModal" className="brands-features__container">
                {brands &&
                  brands.map((brand, index) => (
                    <BrandFeaturesTable
                      key={index}
                      currentBrand={brand}
                      emblaApi={emblaApi}
                      setShowCarousel={setShowCarousel}
                    />
                  ))}
              </div>
            </div>
          </section>
        </div>
        <div className="rewards-brands__backdrop"></div>
      </>
    );
  }
  return null;
}
